import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DropdownMultiselectItem } from '@bayclubs/drop-down';
import moment from 'moment';
import { camps } from '../../../models/models.generated';
import { FilterApiService } from '../../../services/api/filter-api.service';

@Component({
    selector: 'app-camp-enrollment-session-search-criteria',
    templateUrl: './session-search-criteria.component.html',
    styleUrls: ['./session-search-criteria.component.scss'],
    standalone: false
})
export class SessionSearchCriteriaComponent implements OnInit {
    public clubDropdownItems: DropdownMultiselectItem[] = [];
    public categorieDropdownItems: DropdownMultiselectItem[] = [];
    public monthsDropdownItems: DropdownMultiselectItem[] = [];
    public ageDropdownItems: DropdownMultiselectItem[] = [];

    public isBusy: boolean = true;

    @Input()
    public searchForm: UntypedFormGroup;

    constructor(private filters: FilterApiService) {}

    ngOnInit() {
        this.loadFilters();
    }

    private loadFilters() {
        this.isBusy = true;
        this.filters.get(false).subscribe((data) => {
            if (data.isSuccess) {
                this.clubDropdownItems = data.value.clubs.map((x) =>
                    this.createDropdownItem(x.id, x.code, true, x.name)
                );
                this.categorieDropdownItems = data.value.categories.map((x) =>
                    this.createDropdownItem(x.id, x.name, true, x.name)
                );
                this.monthsDropdownItems = data.value.months.map((x) =>
                    this.createMonthDropdown(x)
                );
                this.ageDropdownItems = data.value.ages.map((x) =>
                    this.createDropdownItem(x, x, true, x.toString())
                );

                this.isBusy = false;
            }
        });
    }

    private createDropdownItem(
        id,
        value,
        isSelected: boolean = false,
        displayValue: string = null,
        customValue = null,
        parentId = null
    ): DropdownMultiselectItem {
        return <DropdownMultiselectItem>{
            id: id,
            value: value,
            selected: isSelected,
            displayName: displayValue,
            customValue: customValue,
            parentId: parentId,
        };
    }

    private createMonthDropdown(
        month: camps.CampMonthModel
    ): DropdownMultiselectItem {
        const momentDate = moment(month.month.value);

        return <DropdownMultiselectItem>{
            id: 'm' + month.month.value,
            value: month.month.value,
            selected: true,
            displayName:
                momentDate.format('MMMM') + "'" + momentDate.format('YY'),
            childItems: month.weeks.map((x) =>
                this.createDropdownItem(
                    'w' + x.month.value + '_' + x.start.value,
                    x.month,
                    true,
                    moment(x.start.value).format('MMM Do') +
                        ' - ' +
                        moment(x.end.value).format('MMM Do'),
                    <camps.DateRange>{ start: x.start, end: x.weekEnd },
                    'm' + month.month.value
                )
            ),
        };
    }

    public onClubsChanged(data: Array<DropdownMultiselectItem>) {
        let clubCodes = data.map((x) => x.id);

        this.searchForm.controls['clubCodes'].setValue(clubCodes);
    }

    public onCategoryChanged(data: Array<DropdownMultiselectItem>) {
        let categories = data.map((x) => x.id);

        this.searchForm.controls['categories'].setValue(categories);
    }

    public onAgeChanged(data: Array<DropdownMultiselectItem>) {
        let ages = data.map((x) => x.id);

        let agesInMonths = [];
        ages.forEach((age) => {
            agesInMonths.push(age * 12);
        });

        this.searchForm.controls['agesInMonths'].setValue(agesInMonths);
    }

    public onWeekChanged(data: Array<DropdownMultiselectItem>) {
        let weeks = [];

        if (data) {
            data.forEach((element) => {
                if (element.childItems) {
                    //is parent
                    element.childItems.forEach((x) => {
                        if (x.selected) {
                            weeks.push(x);
                        }
                    });
                } else {
                    if (element.id.toString().startsWith('w')) {
                        if (element.selected) {
                            let exists =
                                weeks.filter((y) => y.id == element.id).length >
                                0;
                            if (!exists) weeks.push(element);
                        }
                    }
                }
            });
        }

        let weeksAsDateRanges = weeks.map((x) => x.customValue);

        this.searchForm.controls['weeks'].setValue(weeksAsDateRanges);
    }
}
